import { useCallback } from 'react';
import { useFetcher } from 'react-router';

import { useBloomBasename } from '@jane/bloom/hooks/useBloomBasename';
import type { Payload } from '@jane/bloom/routes/$basename.api.user-login/types';
import type { LoginUserResponse } from '@jane/bloom/types/actions/auth';
import { buildFormData } from '@jane/bloom/utils/formData';

export const useLogin = () => {
  const basename = useBloomBasename();
  const fetcher = useFetcher<LoginUserResponse>({
    key: 'user-login',
  });

  const login = useCallback(
    (payload: Payload) => {
      return fetcher.submit(buildFormData(payload), {
        action: `${basename}api/user-login`,
        method: 'post',
        preventScrollReset: true,
      });
    },
    [basename, fetcher]
  );

  return {
    fetcher,
    login,
  };
};
